import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { RenderJob } from '../render-flow.model';
import { RenderFlowService } from '../render-flow.service';

export interface RenderPackDialogData {
  modelId: string;
}

// The library's download button (designer, 2026-10-16): the downloads page's "Optimize for
// platforms" card over the library, instead of a download straight away. Inside a .render-flow
// box, so the page's own card styles hold in the overlay; the job is followed live, so a rename
// shows on the card under it at once.
@Component({
  selector: 'app-render-pack-dialog',
  templateUrl: './render-pack-dialog.component.html',
})
export class RenderPackDialogComponent implements OnDestroy {
  public job?: RenderJob;
  private readonly subscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: RenderPackDialogData,
    private readonly dialogRef: MatDialogRef<RenderPackDialogComponent>,
    flow: RenderFlowService,
  ) {
    this.subscription = flow.job$(data.modelId).subscribe((job) => {
      this.job = job;
      if (!job) {
        dialogRef.close();
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
